import { Text } from '@weareconceptstudio/core';

//* Styles
import CustomCheckboxGroupStyle from './style';

const CustomCheckboxGroup = ({ title, options, selected, onSelect, filterKey }) => {
	//! Handle Select
	const handleSelect = (id) => {
		onSelect(filterKey, String(id));
	};

	return options?.length > 0 ? (
		<CustomCheckboxGroupStyle className='options-container'>
			<Text
				className={'green-1000 p1 font-larken-medium options-title'}
				text={title}
			/>

			<div className='options-content'>
				{options.map((option) => (
					<div
						key={option.id}
						className={`options-wrapper`}
						onClick={() => handleSelect(option.id)}
					>
						<input
							type='checkbox'
							checked={!!selected?.[filterKey]?.includes(String(option.id))}
							onChange={() => handleSelect(option.id)}
						/>

						<div className={`custom-checkbox ${!!selected?.[filterKey]?.includes(String(option.id)) ? 'checked' : ''}`} />

						<Text
							text={option.name}
							className='green-1000 font-fss-light p2 option-label'
						/>
					</div>
				))}
			</div>
		</CustomCheckboxGroupStyle>
	) : null;
};

export default CustomCheckboxGroup;
